<template>
  <div class="list-live-wrapper">
    <b-container fluid>
      <div class="tabs-wrapper">
        <b-row class="mb-15">
          <div class="col-sm-12 ">
            <div align="center" class="cards">
              <b-row>
                <div align="center" id="diffusion-select" class="diffusion-select">
                  <i v-has-permission="'lives_multi_delete'" has-permission="lives_multi_delete" class="icon-trash c-deep-orange-600 clickable"
                    v-show="showTrash" @click="openModalDeleteMultiLive($event)"></i>
                  <b-button variant="link" @click="goToCalendar" class="calendar-lives-btn buttons-link"
                    v-if="isArchived != true">
                    <font-awesome-icon icon="calendar-alt" />
                    <span class="d-none d-md-inline-block ml-1">{{ $t('calendar.title') }}</span>
                  </b-button>
                  <div>
                    <div class="thumbnail-container">
                      <div v-has-permission="'lives_dtable_lives_archived,lives_dtable_lives_endless'"
                        has-permission="lives_dtable_lives_archived,lives_dtable_lives_endless"
                        v-if="isArchived != true">
                        <b-dropdown variant="link" toggle-class="text-decoration-none" class="buttons-link">
                          <template slot="button-content">
                            <a href="#" class="text-decoration-none buttons-link"
                              @click="openDropDownDiffusion()"><font-awesome-icon class="icon-video "
                                :icon="{ prefix: 'fas', iconName: 'video' }" />
                              <span class="d-none d-md-inline-block ">{{
                                $t('modal.setting.diffusion.title')
                              }}</span>
                            </a>
                          </template>
                          <b-dropdown-item @click="changeDiffusion('all')" class="diffusion-items"
                            v-has-permission="'lives_dtable_lives_all'" has-permission="lives_dtable_lives_all" :class="[{ active: titleSelected === 'all' }]">
                            <a target="_blank" class="diffusion-icons ">
                              <svg height="18px" version="1.1" viewBox="0 0 18 18" width="18px"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g fill="#000000" id="Core" transform="translate(-381.000000, -381.000000)">
                                  <g id="select-all" transform="translate(381.000000, 381.000000)">
                                    <path
                                      d="M0,2 L2,2 L2,0 C0.9,0 0,0.9 0,2 L0,2 Z M0,10 L2,10 L2,8 L0,8 L0,10 L0,10 Z M4,18 L6,18 L6,16 L4,16 L4,18 L4,18 Z M0,6 L2,6 L2,4 L0,4 L0,6 L0,6 Z M10,0 L8,0 L8,2 L10,2 L10,0 L10,0 Z M16,0 L16,2 L18,2 C18,0.9 17.1,0 16,0 L16,0 Z M2,18 L2,16 L0,16 C0,17.1 0.9,18 2,18 L2,18 Z M0,14 L2,14 L2,12 L0,12 L0,14 L0,14 Z M6,0 L4,0 L4,2 L6,2 L6,0 L6,0 Z M8,18 L10,18 L10,16 L8,16 L8,18 L8,18 Z M16,10 L18,10 L18,8 L16,8 L16,10 L16,10 Z M16,18 C17.1,18 18,17.1 18,16 L16,16 L16,18 L16,18 Z M16,6 L18,6 L18,4 L16,4 L16,6 L16,6 Z M16,14 L18,14 L18,12 L16,12 L16,14 L16,14 Z M12,18 L14,18 L14,16 L12,16 L12,18 L12,18 Z M12,2 L14,2 L14,0 L12,0 L12,2 L12,2 Z M4,14 L14,14 L14,4 L4,4 L4,14 L4,14 Z M6,6 L12,6 L12,12 L6,12 L6,6 L6,6 Z"
                                      id="Shape" />
                                  </g>
                                </g>
                              </svg>
                            </a>
                            <span class="diffusion-title ">{{
                              $t('modal.setting.diffusion.all')
                            }}</span></b-dropdown-item>
                          <b-dropdown-item @click="changeDiffusion('archived')" class="diffusion-items"
                            v-has-permission="'lives_dtable_lives_archived'"
                            has-permission="lives_dtable_lives_archived"
                            :class="[{ active: titleSelected === 'archived' }]">
                            <a target="_blank" class="diffusion-icons "><font-awesome-icon
                                :icon="{ prefix: 'fas', iconName: 'archive' }" /></a>
                            <span class="diffusion-title ">{{
                              $t('modal.setting.diffusion.archived')
                            }}</span></b-dropdown-item>

                          <b-dropdown-item @click="changeDiffusion('endless')" class="diffusion-items"
                            v-has-permission="'lives_dtable_lives_endless'"
                            has-permission="lives_dtable_lives_endless"
                            :class="[{ active: titleSelected === 'endless' }]">
                            <a target="_blank" class="diffusion-icons "><font-awesome-icon
                                :icon="{ prefix: 'fas', iconName: 'play' }" /></a>
                            <span class="diffusion-title ">{{
                              $t('modal.setting.diffusion.endless')
                            }}</span>
                          </b-dropdown-item>
                          <b-dropdown-item @click="changeDiffusion('upcoming')" class="diffusion-items"
                            v-has-permission="'lives_dtable_lives_upcoming'"
                            has-permission="lives_dtable_lives_upcoming"
                            :class="[{ active: titleSelected === 'upcoming' }]">
                            <a target="_blank" class="diffusion-icons ">
                              <svg height="24px" version="1.1" viewBox="0 0 24 24" width="24px"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Artboard-1" transform="translate(-395.000000, -119.000000)">
                                  <path
                                    d="M397.181376,129 C398.121889,123.879764 402.60786,120 408,120 C414.075133,120 419,124.924867 419,131 C419,137.075133 414.075133,142 408,142 C403.727268,142 400.023517,139.563904 398.201917,136.004883 L400.51882,136.004883 C402.133783,138.414115 404.88169,140 408,140 C412.970563,140 417,135.970563 417,131 C417,126.029437 412.970563,122 408,122 C403.716825,122 400.132475,124.992022 399.223016,129 L397.181376,129 L397.181376,129 Z M407.5,131.349626 L412.710685,134.421329 L413.218515,133.559872 L408.5,130.754395 L408.5,124.031738 L407.5,124.031738 L407.5,131.349626 Z M398,133 L401,129 L395,129 L398,133 Z"
                                    fill="#000000" id="circle-backup-time-history-recent-time-machine-glyph" />
                                </g>
                              </svg>
                            </a>
                            <span class="diffusion-title ">{{
                              $t('modal.setting.diffusion.upcoming')
                            }}</span></b-dropdown-item>
                          <b-dropdown-item @click="changeDiffusion('trash')" class="diffusion-items"
                            v-has-permission="'lives_dtable_lives_trash'"
                            has-permission="lives_dtable_lives_trash"
                            :class="[{ active: titleSelected === 'trash' }]">
                            <a target="_blank" class="diffusion-icons ">
                              <i class="icon-trash icons-trash-diffusion clickable"></i>
                            </a>
                            <span class="diffusion-title ">{{
                              $t('modal.setting.diffusion.trash')
                            }}</span></b-dropdown-item>
                        </b-dropdown>
                        <br />
                        <span class="d-none d-md-inline-block title-selected">-- {{ $t('modal.setting.diffusion.' +
                          titleSelected) }} --</span>
                      </div>
                    </div>
                  </div>
                </div>
                <b-col class="flex-grow-1">
                  <b-form-group class="mb-0 input-search ">
                    <b-input-group>
                      <b-input-group-prepend>
                        <font-awesome-icon icon="search" />
                      </b-input-group-prepend>
                      <b-form-input v-model="filter" :placeholder="$t('parameters.search.title') + ',' + $t('parameters.search.description')
                        " @input="searchFilter($event)"></b-form-input>
                      <b-input-group-append>
                        <font-awesome-icon icon="filter" @click="toggleFilter" id="toggle-filter" />
                      </b-input-group-append>
                    </b-input-group>
                    <transition name="fade">
                      <div class="filter-wrapper text-left" v-show="active" v-click-outside="hideFilter">
                        <b-row>
                          <b-col md="6" sm="12">
                            <label>{{ $t('parameters.filter.period') }}</label>
                            <b-form-group>
                              <v-select :disabled="!!mdTime.date" :options="periods" v-model="period"
                                @input="getLivesByParams($event.value, 'period')">
                                <span slot="no-options">
                                  {{ $t('parameters.filter.no_options') }}
                                </span>
                              </v-select>
                            </b-form-group>
                          </b-col>
                          <b-col md="6" sm="12">
                            <label>{{ $t('parameters.filter.date') }}</label>
                            <b-form-group>
                              <div id="filter-date" class="input_css input filter-date ">
                                <datepicker :disabled="!!period" id="start-date" v-model="mdTime.date"
                                  input-class="form-control selectedDate" wrapper-class="start-date-picker"
                                  :bootstrap-styling="true" :calendar-button="true" :required="true" :lang="$i18n.locale"
                                  :format="'DD MMM YYYY'" :active-color="getActiveColor" :clearable="false"
                                  :placeholder="$t('date.placeholder')" @input="getLivesByParams($event, 'startDate')"
                                  @clear="clearFilterDateLives('startDate')">
                                  <template slot="calendar-icon">
                                    <font-awesome-icon class="calendar-icon "
                                      :icon="{ prefix: 'fas', iconName: 'calendar-alt' }" />
                                  </template>
                                </datepicker>
                              </div>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                         <b-col>
    <label>{{ $t('parameters.filter.contributors') }}</label>
    <b-form-group>
      <v-select 
        :options="formattedContributors" 
        label="name" 
        @input="getLivesByContributor($event)"
        v-model="selectedContributor"
        :filterable="true">
        <span slot="no-options">
          {{ $t('parameters.filter.no_contributor') }}
        </span>
        <template slot="option" slot-scope="option">
          <span :class="option.icon"></span>
          {{ option.name }}
        </template>
      </v-select>
    </b-form-group>
  </b-col>
                        </b-row>
                        <b-row>
                          <b-col class="text-right">
                            <button :variant="headerBgVariant" @click="search()" type="button"
                              class="submit reset-filter-btn">{{ $t('parameters.filter.search') }}</button>
                            <button class="submit filter-btn" variant="light" @click="reset">
                              {{ $t('parameters.filter.reset') }}
                            </button>
                          </b-col>
                        </b-row>
                      </div>
                    </transition>
                  </b-form-group>
                </b-col>
                <div class="flex-grow-0 btn-add-live " v-if="isArchived != true">
                  <b-button v-has-permission="'lives_post_add'" has-permission="lives_post_add" :variant="headerBgVariant"
                    class="button-add buttons-primary" @click="GoToAddLive">
                    <!--<font-awesome-icon icon="plus" />-->
                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-1" width="24" height="24" viewBox="0 0 30 30">
                      <path id="Color"
                        d="M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z"
                        transform="translate(3.75 3.75)" fill="#ffffff"></path>
                    </svg>

                    <span class="d-none d-md-inline-block ml-20">{{ $t('button.add') }}</span>
                  </b-button>
                </div>
              </b-row>
            </div>
          </div>
        </b-row>

        <b-row>
          <div class="col-sm-12 list-container">
            <div align="center" class="cards">
              <VuePerfectScrollbar ref="ps-chapters" class="table-wrapper">
                <b-table thead-top show-empty v-model="tableValues" id="table-list-lives" per-page="0"
                  class="tableFixHead" :busy="isBusy" :items="allLives" :fields="fields" :current-page="currentPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                  :checkedAll="checkedAll" @filtered="onFiltered" @sort-changed="sortingChanged"
                  @head-clicked="clearSelected($event)">
                  <template slot="HEAD_check" slot-scope="head">
                    {{ head.label }}
                    <b-form-checkbox v-model="allSelected" @change="checkAllLiveRows($event)"
                      :indeterminate.sync="indeterminate" :button-variant="headerBgVariant" switches></b-form-checkbox>
                  </template>
                  <template slot="check" slot-scope="row">
                    <b-form-checkbox :name="'checked-' + row.item.id.toString()" :id="'check-' + row.item.id.toString()"
                      :key="row.item.id" @change="CheckRowLive($event, row)" :checked="checked"
                      :button-variant="headerBgVariant" switches></b-form-checkbox>
                  </template>
                  <template slot="thumbnail" slot-scope="row">
                    <b-img :src="row.item.thumbnail || getDefaultThumb" class="fluid brad-3 thumbnail-image"
                      alt="thumbnail Image" />
                    <div class="metadata-info">
                      <rating-stars v-has-permission="'lives_dtable_show_vote'" has-permission="lives_dtable_show_vote" :nbVote="row.item.nbVote"
                        :id="row.item.id" v-if="!isNaN(row.item.nbVote)"></rating-stars>
                      <like-dislike v-has-permission="'lives_dtable_show_like,lives_dtable_show_not_like'" has-permission="lives_dtable_show_like,lives_dtable_show_not_like"
                        :nbLike="row.item.nbLike" :nbNotLike="row.item.nbNotLike"
                        v-if="!isNaN(row.item.nbLike + row.item.nbNotLike)"></like-dislike>
                    </div>
                  </template>
                  <template slot="dateStart" slot-scope="row">
                  <span>{{ row.item.dateStart | moment(' DD/MM/YYYY ') }} </span>                
                   <br />
                  <span>{{ row.item.dateStart | moment('HH:mm:ss') }} </span>                  </template>
                  <template slot="active" slot-scope="row" style="width: 30%">
                    <b-form-group>
                      <span v-model="row.item.active" class="badge" :class="getStatut(row.item).class">
                        {{ $t('statut.' + getStatut(row.item).text) }}
                      </span>
 

                      <!--                      <b-form-radio-->
                      <!--                        v-model="row.item.active"-->
                      <!--                        :name="'some-radios-' + row.item.id"-->
                      <!--                        :value="getActiveLive(row.item.active, row.item.id)"-->
                      <!--                        disabled-->
                      <!--                        @change="ChangeActivity($event, row.item.id)"-->
                      <!--                        :button-variant="getButtonVariant(row.item.active)"-->
                      <!--                        :variant="getButtonVariant(row.item.active)"-->
                      <!--                      ></b-form-radio>-->
                    </b-form-group>
                  </template>
                  <template slot="actions" slot-scope="row">
                    <actions-buttons :row="row"></actions-buttons>
                  </template>
                  <template slot="empty" slot-scope="scope" class="my-5 text-center">
                    <div class="my-5 text-center">{{ $t('table.empty') }}</div>
                  </template>
                  <div slot="table-busy" class="my-5 text-center">
                    <b-spinner class="align-middle"
                      style="width: 1.5rem;height: 1.5rem;border: 0.15em solid currentColor;border-right-color: transparent;margin-right: 10px;"></b-spinner>
                    <span>Data loading...</span>
                  </div>
                  <!--Mobile version-->
                  <template slot="mobile-details" slot-scope="row">
                    <div class="d-flex flex-column">
                      <div class="d-flex live-content">
                        <div class="live-content__thumbnail-container">
                          <b-img :src="row.item.thumbnail || getDefaultThumb"></b-img>
                        </div>
                        <div class="live-content__data d-flex flex-column">
                          <div class="live-content__data__title">
                            <h4>{{ row.item.title }}</h4>
                            <!--<p>{{ row.item.description }}</p>-->
                          </div>
                          <div class="live-content__data__date">
                            {{ row.item.dateStart | moment(' DD/MM/YYYY') }}
                            <div>
                              <font-awesome-icon icon="clock" />
                              {{ row.item.dateStart | moment('HH:mm:ss') }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template slot="show_details" slot-scope="row">
                    <b-button variant="link" class="show-actions-btn c-grey-700" @click="row.toggleDetails"
                      :class="{ active: row.detailsShowing }">
                      <font-awesome-icon icon="ellipsis-v" />
                    </b-button>
                  </template>
                  <template slot="row-details" slot-scope="row">
                    <div class="actions-container" v-show="row.item._showDetails">
                      <actions-buttons :row="row"></actions-buttons>
                    </div>
                  </template>
                </b-table>
              </VuePerfectScrollbar>
              <div class="border-top p-15">
                <b-row>
                  <b-col class="d-none d-md-flex justify-content-start align-items-center">
                    <span style="padding-right: 10px">{{ $t('table.pagination.show') }}</span>
                    <b-form-group class="mb-0"><!--label-cols-sm="3" label="Per page"-->
                      <b-form-select v-model="perPage" :options="pageOptions" value-field="item" text-field="name"
                        :aria-selected="perPage" @change="changePerPage($event)"></b-form-select>
                    </b-form-group>
                    <span style="padding-left: 10px">{{ $t('table.pagination.elements') }}</span>
                    <span v-if="getTotalLive"> / {{ getTotalLive }}</span>
                    <span v-else>/ 0</span>
                  </b-col>
                  <b-col
                    class="d-flex justify-content-start align-items-center position-relative justify-content-end lives-pagination">
                    <b-pagination v-model="currentPage" :total-rows="getTotalLive" :per-page="perPage"
                      :first-text="$t('table.pagination.first')" :prev-text="$t('table.pagination.prev')"
                      :next-text="$t('table.pagination.next')" :last-text="$t('table.pagination.last')"
                      @change="changeNumPage($event)" class="mb-0 buttons-link "
                      :variant="headerBgVariant"></b-pagination>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </b-row>

        <b-modal scrollable :title="$t('modal.view.title') + getLive['title']" size="lg" id="modal-view-row"
          ref="modal-view-row" header-class="buttons-primary" :header-bg-variant="headerBgVariant"
          :header-text-variant="headerTextVariant">
          <b-container><!--v-if="showAllSlides"-->
            <b-row class="mb-1 text-center live-details">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.id') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value">{{ getLive['id'] }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.title') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value">{{ getLive['title'] }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.description') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value">{{ getLive['description'] }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.tags') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value">{{ getLive['tags'] }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.date') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value">{{ getLive['dateStart'] | moment(' DD/MM/YYYY (HH:mm:ss') }} -
                  {{ getLive['dateEnd'] | moment('HH:mm:ss)') }}
                </b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_private_no_api'" has-permission="lives_private_no_api">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.private') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['private'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_autopub_no_api'" has-permission="lives_autopub_no_api">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.automatic_share') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['autoPub'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_active_no_api'" has-permission="lives_active_no_api">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.active') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['active'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.vignette') }}</span>
              </b-col>
              <b-col class="live-column">
                <b-img :src="getLive['thumbnail'] || getDefaultThumb" class="fluid brad-3" alt="thumbnail Image" />
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_fo_like_no_api'" has-permission="lives_fo_like_no_api">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.like') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['foLike'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_fo_sondage_no_api'" has-permission="lives_fo_sondage_no_api">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.poll') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['foSondage'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_fo_subscript_no_api'" has-permission="lives_fo_subscript_no_api">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.registration') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['foSubscript'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_fo_comment_no_api'" has-permission="lives_fo_comment_no_api">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.send_mails') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['foComment'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_fo_files_share_no_api'" has-permission="lives_fo_files_share_no_api">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.share_file') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['foFilesShare'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_screen_share_no_api'" has-permission="lives_screen_share_no_api">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.screen_share') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['screenShare'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-1 text-center live-details" v-has-permission="'lives_conf_post_add'" has-permission="lives_conf_post_add">
              <b-col class="live-column">
                <span class="live-title">{{ $t('modal.view.params.config') }}</span>
              </b-col>
              <b-col class="live-column">
                <b class="live-value" v-if="getLive['defaultConf'] === true">{{
                  $t('modal.view.params.yes')
                }}</b>
                <b class="live-value" v-else>{{ $t('modal.view.params.no') }}</b>
              </b-col>
            </b-row>
          </b-container>
          <div slot="modal-footer" class="w-100" style="border-top: none">
            <b-button variant="light" size="sm" class="float-right buttons-modal" id="btn_cancel"
              @click="closeViewModalById()">
              {{ $t('modal.view.btn_cancel') }}
            </b-button>
          </div>
        </b-modal>
        <b-modal size="lg" :title="$t('modal.infos.title') + getInfoDetailLive['title']" style="font-size: 15px"
          id="modal-infos-live-row" ref="modal-infos-live-row" :header-bg-variant="headerBgVariant"
          :header-text-variant="headerTextVariant">
          <b-container fluid style="border-bottom: none">
            <template v-for="(item, index) in getInfoDetailLive['streamingURLs']">
              <b-row class="mb-1 text-center">
                <span class="live-diffusion-title">{{ $t('modal.infos.url_diffusion') }} {{ index + 1 }}</span>
              </b-row>
              <b-row class="mb-1 text-center link-key">
                <label>{{ $t('modal.infos.link') }}</label>
                <input class="form-control" :value="item.link" disabled />
              </b-row>
              <b-row class="mb-1 text-center link-key">
                <label>{{ $t('modal.infos.key') }}</label>
                <input class="form-control" :value="item.key" disabled />
              </b-row>
            </template>
            <b-row>
              <span v-if="(getInfoDetailLive['login'] !== '' || getInfoDetailLive['pwd'] !== '' || (!getInfoDetailLive['is_pearl'] && getInfoDetailLive['token'] ))" class="separator"></span>
            </b-row>
            <b-row class="mb-1 text-center" v-if="(getInfoDetailLive['login'] !== null) && (getInfoDetailLive['login'] !== '')">
              <span class="live-diffusion-title">{{ $t('modal.infos.login') }}</span>
            </b-row>
            <b-row v-if="(getInfoDetailLive['login'] !== null) && (getInfoDetailLive['login'] !== '')" class="mb-1 text-center">
              <input class="form-control" :value="getInfoDetailLive['login']" :placeholder="$t('modal.infos.login')" disabled />
            </b-row>
            <b-row class="mb-1 text-center">
              <span class="live-diffusion-title" v-if="(getInfoDetailLive['pwd'] !== null) && (getInfoDetailLive['pwd'] !== '')">{{ $t('modal.infos.pass') }}</span>
            </b-row>
            <b-row v-if="(getInfoDetailLive['pwd'] !== null) && (getInfoDetailLive['pwd'] !== '')" class="mb-1 text-center">
              <input class="form-control" :value="getInfoDetailLive['pwd']" :placeholder="$t('modal.infos.pass')"
                disabled />
            </b-row>
            <b-row class="mb-1 text-center" v-has-permission="'lives_export_token'" has-permission="lives_export_token" v-if="!getInfoDetailLive['is_pearl'] && (getInfoDetailLive['token'] !== null) && (getInfoDetailLive['token'] !== '')">
              <span class="live-diffusion-title">Token</span>
            </b-row>
            <b-row class="mb-1 text-center" v-if="(!getInfoDetailLive['is_pearl'] && getInfoDetailLive['token'] !== null) && (getInfoDetailLive['token'] !== '')" v-has-permission="'lives_export_token'" has-permission="lives_export_token">
              <input class="form-control" :value="getInfoDetailLive['token']" placeholder="token live" disabled />
            </b-row>
          </b-container>
          <div slot="modal-footer" class="w-100" style="border-top: none">
            <b-button variant="light" size="sm" class="float-right buttons-modal" id="btn_cancel"
              @click="closeInfosModal()"><!-- -->
              {{ $t('modal.infos.btn_cancel') }}
            </b-button>
          </div>
        </b-modal>
        <b-modal scrollable size="lg" :title="$t('modal.export.title') + getLinkExportLives['title']"
          style="font-size: 15px" id="modal-link-export-row" ref="modal-link-export-row" class="buttons-primary"
          :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant">
          <b-container fluid style="border-bottom: none">
            <b-row class="mb-1 text-row-export export-position"
              v-if="getUseJitsi && getLinkExportLives['url_export_admin']">
              <b-col sm="3">
                <span class="text-export">{{ $t('modal.export.url') }}</span>
              </b-col>
              <b-col sm="7">
                <div>
                  <input ref="url_export" class="form-control live-title live-text-title"
                    :value.sync="getLinkExportLives['url_export_admin']" readonly />
                </div>
              </b-col>
              <b-col sm="2">
                <b-button variant="light" size="sm" class="float-left multi-buttons buttons-modal"
                  :class="['link-button', { 'is-active': clickedUrlExport }]"
                  @click="copyExportLink($event, 'url_export')">
                  <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'check' }" class=" check-icon"
                    v-if="clickedUrlExport" />
                  <span v-else>{{ $t('modal.export.copy') }}</span>
                </b-button>
              </b-col>
            </b-row>
            <div v-if="Array.isArray(getLinkExportLives['permalien'])">
              <b-row class="mb-1 text-row-export permalink-position" v-if="getLinkExportLives['permalien'].length >= 1 &&
                getLinkExportLives['permalien'].length !== 2
                ">
                <b-col sm="3">
                  <span class="text-export text-export-position">{{
                    $t('modal.export.permalink')
                  }}</span>
                </b-col>
                <b-col sm="9" class="text-export-col-position">
                  <b-row class="mb-1" v-for="(permalink, index) in getLinkExportLives['permalien']" :key="index">
                    <b-col sm="9">
                      <input ref="permalink"
                        class="form-control multi-links live-title  live-text-title live-text-position"
                        :value.sync="permalink" readonly />
                    </b-col>
                    <b-col sm="3">
                      <b-button variant="light" size="sm"
                        class="float-left multi-buttons buttons-modal multi-buttons-position" :class="[
                          'link-button',
                          { 'is-active': clickedPermalink && permalinkIndex === index },
                        ]" @click="copyExportLink($event, 'permalink', index)">
                        <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'check' }" class=" check-icon"
                          v-if="clickedPermalink && permalinkIndex === index" />
                        <span v-else>{{ $t('modal.export.copy') }} </span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row 
  class="mb-1 text-row-export" 
  v-if="getLinkExportLives['permalien'].length === 2" 
  v-for="(permalink, index) in getLinkExportLives['permalien']" 
  :key="index">
                <b-col sm="3" v-if="permalink">
                  <span class="text-export " v-text="getNamePermalink(permalink)"></span>
                </b-col>
                <b-col sm="7" v-if="permalink">
                  <input ref="permalink" class="form-control multi-links live-title  live-text-title live-text-position"
                    :value.sync="permalink" readonly />
                </b-col>
                <b-col sm="2" v-if="permalink">
                  <b-button variant="light" size="sm"
                    class="float-left multi-buttons buttons-modal multi-buttons-position" :class="[
                      'link-button',
                      { 'is-active': clickedPermalink && permalinkIndex === index },
                    ]" @click="copyExportLink($event, 'permalink', index)">
                    <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'check' }" class=" check-icon"
                      v-if="clickedPermalink && permalinkIndex === index" />
                    <span v-else>{{ $t('modal.export.copy') }}</span>
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <b-row class="mb-1 text-row-export export-position">
                <b-col sm="3">
                  <span class="text-export">{{ $t('modal.export.permalink') }}</span>
                </b-col>
                <b-col sm="7">
                  <input ref="permalink" class="form-control live-title live-text-title"
                    :value.sync="getLinkExportLives['permalien']" readonly />
                </b-col>
                <b-col sm="2">
                  <b-button variant="light" size="sm" class="float-left multi-buttons buttons-modal"
                    :class="['link-button', { 'is-active': clickedPermalink }]"
                    @click="copyExportLink($event, 'permalink')">
                    <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'check' }" class=" check-icon"
                      v-if="clickedPermalink" />
                    <span v-else>{{ $t('modal.export.copy') }}</span>
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <b-row class="mb-1 text-row-export">
              <b-col sm="3">
                <span class="text-export">{{ $t('modal.export.embed') }}</span>
              </b-col>
              <b-col sm="7" class="textarea-col-position">
                <textarea ref="embed" :class="['form-control']" v-text="iframe" class="textarea-height " readonly>
                </textarea>
              </b-col>
              <b-col sm="2">
                <b-button variant="light" size="sm" class="float-left multi-buttons buttons-modal"
                  :class="['link-button', { 'is-active': clickedEmbed }]" @click="copyExportLink($event, 'embed')">
                  <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'check' }" class=" check-icon"
                    v-if="clickedEmbed" />
                  <span v-else>{{ $t('modal.export.copy') }}</span>
                </b-button>
              </b-col>
            </b-row>

            <!-- <b-row class="mb-1 text-row-export" v-if="this.getLinkExportLives['link_moderator']">
              <b-col sm="3">
                <span class="text-export">{{ $t('modal.export.moderator') }}</span>
              </b-col>
              <b-col sm="7" class="textarea-col-position">
                <input ref="link_moderator" class="form-control live-title live-text-title"
                  :value.sync="this.getLinkExportLives['link_moderator']" readonly />
              </b-col>
              <b-col sm="2">
                <b-button variant="light" size="sm" class="float-left multi-buttons buttons-modal"
                  :class="['link-button', { 'is-active': clickedModerator }]"
                  @click="copyExportLink($event, 'link_moderator')">
                  <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'check' }" class=" check-icon"
                    v-if="clickedModerator" />
                  <span v-else>{{ $t('modal.export.copy') }}</span>
                </b-button>
              </b-col>
            </b-row> -->
            <b-row class="mb-1 text-row-export" v-if="this.getLinkExportLives['link_journalist']">
              <b-col sm="3">
                <span class="text-export">{{ $t('modal.export.journalist') }}</span>
              </b-col>
              <b-col sm="7" class="textarea-col-position">
                <input ref="link_journalist" class="form-control live-title live-text-title"
                  :value.sync="this.getLinkExportLives['link_journalist']" readonly />
              </b-col>
              <b-col sm="2">
                <b-button variant="light" size="sm" class="float-left multi-buttons buttons-modal"
                  :class="['link-button', { 'is-active': clickedJournalist }]"
                  @click="copyExportLink($event, 'link_journalist')">
                  <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'check' }" class=" check-icon"
                    v-if="clickedJournalist" />
                  <span v-else>{{ $t('modal.export.copy') }}</span>
                </b-button>
              </b-col>
            </b-row>
          </b-container>
          <div slot="modal-footer" class="w-100" style="border-top: none">
            <b-button variant="light" size="sm" class="float-right buttons-modal" id="btn_cancel"
              @click="closeExportLinkModal()">
              {{ $t('modal.infos.btn_cancel') }}
            </b-button>
          </div>
        </b-modal>
        <b-modal size="lg" :title="$t('modal.send_invitations.title')" id="modal-send-invitations-row"
          ref="modal-send-invitations-row" class="buttons-primary" :header-bg-variant="headerBgVariant"
          :header-text-variant="headerTextVariant">
          <b-container fluid style="border-bottom: none">
            <b-row class="mb-1 text-center">
              <div v-for="(user, index) in getSubscriptionUser" :key="index" :class="['userItem']">
                <span class="" :class="[
                  'userSpan',
                  {
                    ['is-selected']: invitations[invitations.indexOf(user.email)],
                  },
                ]" @click="selectUser($event, user.email)">{{ user.email }}</span>
              </div>
            </b-row>
          </b-container>
          <div slot="modal-footer" class="w-100" style="border-top: none">
            <b-button class="float-right buttons-modal buttons-primary" id="btn_send" :variant="headerBgVariant"
              :disabled="!selectedUser" @click="sendInvitationMail()">
              {{ $t('button.send') }}
            </b-button>
            <b-button variant="light" class="float-right buttons-modal" id="btn_cancel"
              @click="closeSendInvitationsModal()">
              {{ $t('button.cancel') }}
            </b-button>
          </div>
        </b-modal>
        <b-modal size="lg" :title="$t('modal.send_invitations.title')" id="modal-send-group-mails-row"
          ref="modal-send-group-mails-row" :class="['buttons-primary']" :header-bg-variant="headerBgVariant"
          :header-text-variant="headerTextVariant">
          <b-container fluid style="border-bottom: none">
            <b-row class="mb-1 text-center group-mails" v-show="!form.defaultChoice">
              <div class="add-emails">
                <label class="primary text-email ">{{
                  $t('modal.send_group_mails.send_mails.text')
                }}</label>
                <b-button variant="outline-primary"
                  class="float-right buttons-modal buttons-group-mails button-add-mail buttons-outline-primary"
                  id="btn_add_email" @click="goToAddEmailsModal()"><!-- -->
                  <font-awesome-icon class="actionIcons icon-add-email" :icon="{ prefix: 'fas', iconName: 'plus' }" />
                  {{ $t('button.add_emails') }}
                </b-button>
              </div>

              <VuePerfectScrollbar ref="ps-group-mails" class="scroll-area-group scroll-group-list">
                <label class="primary label-group-list">{{
                  $t('modal.send_group_mails.send_mails.groupLabel')
                }}</label>
                <div class="list-groups">
                  <div class="group-mails__all__list">
                    <div v-for="(user, index) in getSubscriptionGroupUsers" :key="index" :class="[
                      'group-mails__all__list__user',
                      {
                        ['is-group-selected']:
                          groupInvitations[groupInvitations.indexOf(user.id)],
                      },
                    ]" @click="selectGroupUser($event, user.id)">
                      {{ user.name }}
                    </div>
                  </div>
                </div>
                <label class="primary label-mail-list">{{
                  $t('modal.send_group_mails.send_mails.mailLabel')
                }}</label>
                <div class="list-groups">
                  <div class="group-mails__all__list">
                    <span class="group-mails__all__list__email" v-if="form.emails.length > 0"
                      v-for="(item, iteration) in form.emails" :key="iteration">
                      {{ form.emails[iteration] }}
                      <a class="remove" @click="removeAddedMail(form.emails[iteration])"></a>
                    </span>
                  </div>
                </div>
              </VuePerfectScrollbar>
            </b-row>
            <b-row class="mb-1 text-center" v-show="form.defaultChoice">
              <div class="form-group form-email">
                <label class="primary text-email">{{
                  $t('modal.send_group_mails.insert_mails.text')
                }}</label>
                <label class="primary label-email">{{
                  $t('modal.send_group_mails.insert_mails.label')
                }}</label>
                <input-tag v-model="form.emails" validate="email" class="input-email"></input-tag>
              </div>
            </b-row>
          </b-container>
          <div slot="modal-footer" class="w-100" style="border-top: none" v-if="!form.defaultChoice">
            <b-button class="float-right buttons-modal buttons-group-mails buttons-primary" id="btn_send"
              :variant="headerBgVariant" :disabled="disabledSendButton" @click="sendInvitationGroupMails()">
              {{ $t('button.send') }}
            </b-button>
            <b-button variant="light" class="float-right buttons-modal buttons-group-mails" id="btn_cancel"
              @click="closeSendGroupInvitationsModal()">
              {{ $t('button.cancel') }}
            </b-button>
          </div>
          <div slot="modal-footer" class="w-100" style="border-top: none" v-if="form.defaultChoice">
            <b-button class="float-right buttons-modal buttons-group-mails buttons-primary" id="btn_send"
              :disabled="form.emails.length === 0" :variant="headerBgVariant" @click="addNewEmail(form.emails)">
              {{ $t('button.add') }}
            </b-button>
            <b-button variant="light" class="float-right buttons-modal buttons-group-mails " id="btn_cancel"
              @click="cancelAddGroupMailsModal()">
              {{ $t('button.cancel') }}
            </b-button>
          </div>
        </b-modal>
        <b-modal size="lg" :title="$t('modal.screen_share.title')" id="modal-screen-share-row"
          ref="modal-screen-share-row" class="buttons-primary" :header-bg-variant="headerBgVariant"
          :header-text-variant="headerTextVariant">
          <b-container fluid style="border-bottom: none"><!--v-if="showAllSlides"-->
            <b-row class="mb-1 text-center">
              <span>{{ $t('modal.screen_share.type') }}</span>
            </b-row>
            <b-row class="mb-1 text-center">
              <b-form-select v-model="screenType" :options="screenTypeOptions"></b-form-select>
            </b-row>
          </b-container>
          <div slot="modal-footer" class="w-100" style="border-top: none">
            <b-button class="float-right buttons-modal buttons-primary" id="btn_send" :variant="headerBgVariant"
              @click="updateScreenShare(screenType)"><!-- -->
              {{ $t('button.validate') }}
            </b-button>
            <b-button variant="light" class="float-right buttons-modal" id="btn_cancel"
              @click="closeScreenShareModal()"><!-- -->
              {{ $t('button.cancel') }}
            </b-button>
          </div>
        </b-modal>
        <b-modal size="lg" :title="$t('modal.show_archived_live.title')" id="modal-preview-archived-video"
          ref="modal-preview-archived-video" class="buttons-primary" :header-bg-variant="headerBgVariant"
          :header-text-variant="headerTextVariant">
          <b-container fluid style="border-bottom: none">
            <b-row class="mb-1 text-center" v-if="getLinkArchivedVideo.code === 200">
              <b-embed type="iframe" aspect="16by9" :src="getLinkArchivedVideo.data.link" allowfullscreen></b-embed>
            </b-row>
            <b-row class="mb-1 no-archived-position"
              v-if="getLinkArchivedVideo.code === 404 || getLinkArchivedVideo.code === 500">
              <b-img :src="noArchivedVideo" class="no-archived-img"></b-img>

              <span class="no-archived-text">{{ $t('modal.show_archived_live.not_found') }}</span>
            </b-row>
            <b-row class="mb-1 no-archived-position" v-if="getLinkArchivedVideo.code === 400">
              <b-img :src="noArchivedVideo" class="no-archived-img"></b-img>

              <span class="no-archived-text">{{
                $t('modal.show_archived_live.not_transcripted')
              }}</span>
            </b-row>
          </b-container>
          <div slot="modal-footer" class="w-100" style="border-top: none">
            <b-button class="float-right buttons-modal buttons-primary" id="btn_send" :variant="headerBgVariant"
              @click="closeModalArchivedVideo()">
              {{ $t('button.ok') }}
            </b-button>
          </div>
        </b-modal>

        <b-modal size="lg" :title="$t('modal.direct.' + getStatusLive + '.title')"
          :id="'modal-' + getStatusLive + '-live'" :ref="'modal-' + getStatusLive + '-live'" class="buttons-primary"
          :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" @hide="closeStatusModal()">
          <div class="subTitles"> {{ $t('modal.direct.' + getStatusLive + '.subtitle') }} </div>
          <div slot="modal-footer" class="w-100" style="border-top: none">
            <b-button class="float-right buttons-modal buttons-primary" id="btn_send" :variant="headerBgVariant"
              @click="handleStatusModal()">
              {{ $t('button.ok') }} 
            </b-button>
            <b-button variant="light" class="float-right buttons-modal" id="btn_cancel" @click="closeStatusModal()">
              {{ $t('button.cancel') }}
            </b-button>
          </div>
        </b-modal>
        <b-modal size="lg"
          :title="$t('modal.direct.' + getTitleOnDeletedLive + '.title.' + (showTrash ? 'multi' : 'simple'))"
          :id="'modal-' + getTitleOnDeletedLive + '-live'" :ref="'modal-' + getTitleOnDeletedLive + '-live'"
          class="buttons-primary" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant">
          <div class="subTitles"> {{ showTrash ? $t('modal.direct.checked_elements') : liveObject.title }}{{
            $t('modal.direct.' + getTitleOnDeletedLive + '.subtitle.' + (showTrash ? 'multi' : 'simple')) }} </div>
          <div slot="modal-footer" class="w-100" style="border-top: none">
            <b-button class="float-right buttons-modal buttons-primary" id="btn_send" :variant="headerBgVariant"
              @click="handleDeleteLiveModal()">
              {{ $t('button.ok') }}
            </b-button>
            <b-button variant="light" class="float-right buttons-modal" id="btn_cancel" @click="closeDeleteLiveModal()">
              {{ $t('button.cancel') }}
            </b-button>
          </div>
        </b-modal>
        <b-modal size="xl" centered :title="$t('modal.direct.flow')" :id="'modal-flow-live-row'"
          :ref="'modal-flow-live-row'" class="buttons-primary" :header-bg-variant="headerBgVariant"
          :header-text-variant="headerTextVariant" hide-footer>
          <b-container fluid style="border-bottom: none" class="flow--container">
            <iframe :src="getUrlFlow" class="flow-iframe" width="100%" height="100%"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
              webkitallowfullscreen mozallowfullscreen frameborder="0"></iframe>
          </b-container>
        </b-modal>
      </div>

    </b-container>
    <share-link></share-link>
  </div>
</template>

<script>
import Datepicker from 'vue2-datepicker';
// import * as lang from 'vuejs-datepicker/src/locale';
import VueSelect from 'vue-select';
import { mapActions, mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import 'vue-select/src/scss/vue-select.scss';
import i18n from '../i18n/index.js';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
import VueMoment from 'vue-moment';
import * as moment from 'moment';
import 'moment/locale/pt-br';
import Toasted from 'vue-toasted';
import ClickOutside from 'vue-click-outside';
import HasPermission from '../directives/HasPermission.js';
import { acces_send } from '../service/access_service'
import UploadMixin from '../mixins/UploadMixin.js';
import UtilsMixin from '../mixins/UtilsMixin.js';
import NProgress from 'nprogress';
import ActionsButtons from '../components/components/ActionButtons';
import RatingStars from './components/RatingStars';
import LikeDislike from './components/LikeDislike';
import InputTag from 'vue-input-tag';
import '../assets/scss/nprogress.scss';
import ShareLink from './modal/shareLink'
import common from '../helpers/common';

export default {
  name: 'ListLive',
  components: {
    Datepicker,
    'v-select': VueSelect,
    VuePerfectScrollbar,
    VueMoment,
    moment,
    Toasted,
    ActionsButtons,
    RatingStars,
    LikeDislike,
    InputTag,
    ShareLink,
  },
  directives: {
    ClickOutside,
    HasPermission,
  },
  mixins: [UploadMixin, UtilsMixin],
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  data() {
    return {
      isArchived: false,
      currentPage: 1,
      perPage: 20,
      pageOptions: [
        { item: '5', name: '5' },
        { item: '10', name: '10' },
        { item: '20', name: '20' },
        { item: '30', name: '30' },
        { item: '50', name: '50' },
        { item: '100', name: '100' },
      ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'desc',
      filter: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      checkedAll: true,
      mdTime: { date: '', time: '', endtime: '' },
      //languages: lang,
      active: false,
      indeterminate: false,
      tableValues: [],
      totalRows: 1,
      allSelected: false,
      type: 'endless',
      obj: {},
      showTrash: false,
      checkedItems: false,
      selected: [],
      selectedAll: [],
      checked: false,
      isActive: true,
      selectedList: [],
      openModalDelete: false,
      isLoading: false,
      selectedContributor: '',
      substitle: '',
      liveId: '',
      liveObject: '',
      live: {},
      showAllSlides: false,
      diffusionSelected: false,
      numColumn: 0,
      selectedRows: [],
      clickedEmbed: false,
      clickedModerator: false,
      clickedJournalist: false,
      clickedPermalink: false,
      clickedUrlExport: false,
      selectedUser: false,
      selectedGroupUser: false,
      hasGroupMails: false,
      invitations: [],
      groupInvitations: [],
      groupMails: [],
      headerBgVariant: 'primary',
      headerTextVariant: 'white',
      screenType: 'pip',
      screenTypeOptions: [
        { value: 'pip', text: 'Picture in Picture PIP' },
        { value: 'sbs', text: 'Side by Side' },
      ],
      titleSelected: 'all',
      /////newwwww date picker
      time1: '',
      time2: '',
      time3: '',
      // custom lang

      // custom range shortcuts
      shortcuts: [
        {
          text: 'Today',
          onClick: () => {
            this.time3 = [new Date(), new Date()];
          },
        },
      ],
      timePickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30',
      },
      permalinkIndex: '',
      period: '',
      form: {
        defaultChoice: false,
        emails: [],
      },
      show: true,
      colors: {},
      statusLive: 'start',
      titleOnDeletedLive: 'archiving',
      isSatusChanged: false,
      isRestoreingLive: false,
      isArchivingLive: false,
      isMultiDelete: false,
      isArchivedMulti: '',
      urlFlow: ''
    };
  },
  watch: {
    checkedItems(a, b) {
      this.allSelected = this.tableValues.length === a.length;
    },
    allLives:{
      handler(lives) {
        this.syncLivesSockets({ lives, diffusionType: this.getDiffusion });
      },
      deep: true,
      immediate: true,

    },
    getReloadListFlag() {
      // Trigger your method to reload the live list
      this.paginate(this.obj);
    },
  },
  computed: {
    ...mapGetters({
      allLives: 'lives/getAllLives',
      getContributors: 'lives/getContributors',
      getLive: 'lives/getLive',
      getTotalLive: 'lives/getTotalLive',
      isBusy: 'lives/getIsLoading',
      getInfoDetailLive: 'lives/getInfoDetailLive',
      getLinkExportLives: 'lives/getLinkExportLives',
      getSubscriptionUser: 'lives/getSubscriptionUser',
      getSubscriptionGroupUsers: 'lives/getSubscriptionGroupUsers',
      getUseJitsi: 'common/getUseJitsi',
      getDiffusionObject: 'lives/getDiffusionObject',
      getLinkArchivedVideo: 'lives/getLinkArchivedVideo',
      getDiffusion: 'common/getDiffusion',
      defaultThumbnail: 'common/getDefaultThumbnail',
      getArchivedLive: 'lives/getArchivedLive',
      getResponseDelete: 'lives/getResponseDelete',
      getReloadListFlag:'socket/getReloadListFlag'
    }),
    getFirstUniquePermalink() {
    const filteredPermalinks = this.getLinkExportLives['permalien'].filter((perm) => perm.includes('/live-event/'));
    return filteredPermalinks.length > 0 ? [filteredPermalinks[0]] : [];
  },
     formattedContributors() {
      return this.getContributors.map(contributor => ({
        id: contributor.id,
        name: `${contributor.name}`,
      }));
    }
  ,
    getUrlFlow() {
      return this.urlFlow;
    },
    isTrashDiffusion() {
      return this.getDiffusion === 'trash'
    },
    isArchivingMultiLive() {
      return this.isArchivedMulti === 'archiving';
    },
    getStatusLive() {
      return this.statusLive
    },
    getTitleOnDeletedLive() {
      return this.titleOnDeletedLive
    },
    getDefaultThumb() {
      return process.env.BASE_HREF + 'liste-lives/static/vignette/' + this.thumbnail
    },
    iframe() {
      return (
        '<iframe style="width:100%;height:100%;min-height:560px" src="' +
        this.getLinkExportLives['embed'] +
        '" allowfullscreen mozallowfullscreen webkitallowfullscreen frameborder="0" allow="autoplay;"></iframe>'
      );
    },
    thumbnail() {
      let defaultTumbnail = 'vignette_purple.jpg';
      if (window.process.env.ISFM && window.process.env.ISFM !== "false") {
        defaultTumbnail = 'vignette_green.jpeg'
      }
      if (this.defaultThumbnail && this.defaultThumbnail !== null && this.defaultThumbnail !== '' && this.defaultThumbnail !== undefined) {
        defaultTumbnail = this.defaultThumbnail;
      }
      return defaultTumbnail
    },
    noArchivedVideo() {
      return 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MCA4MCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBmaWxsPSIjODM5Y2IyIiBkPSJNMzIuNSA1NC41SDQ3LjVWNjcuNUgzMi41eiIvPjxwYXRoIGZpbGw9IiM2Njc5OGYiIGQ9Ik00Nyw1NXYxMkgzM1Y1NUg0NyBNNDgsNTRIMzJ2MTRoMTZWNTRMNDgsNTR6Ii8+PHBhdGggZmlsbD0iI2IwYzFkNCIgZD0iTTE3LjUgNjQuNUg2Mi41VjcwLjVIMTcuNXoiLz48cGF0aCBmaWxsPSIjNjY3OThmIiBkPSJNNjIsNjV2NUgxOHYtNUg2MiBNNjMsNjRIMTd2N2g0NlY2NEw2Myw2NHoiLz48cGF0aCBmaWxsPSIjZjJmYWZmIiBkPSJNMS41IDkuNUg3OC41VjU3LjVIMS41eiIvPjxwYXRoIGZpbGw9IiM3ODhiOWMiIGQ9Ik03OCwxMHY0N0gyVjEwSDc4IE03OSw5SDF2NDloNzhWOUw3OSw5eiIvPjxnPjxwYXRoIGZpbGw9IiNmNzhmOGYiIGQ9Ik0xMi41LDM5LjV2LTM5aDU1djM5SDEyLjV6IE01OC41LDM2LjVoNnYtNmgtNlYzNi41eiBNMTUuNSwzNi41aDZ2LTZoLTZWMzYuNXogTTU4LjUsMjcuNWg2di02aC02IFYyNy41eiBNMTUuNSwyNy41aDZ2LTZoLTZWMjcuNXogTTU4LjUsMTguNWg2di02aC02VjE4LjV6IE0xNS41LDE4LjVoNnYtNmgtNlYxOC41eiBNNTguNSw5LjVoNnYtNmgtNlY5LjV6IE0xNS41LDkuNWg2di02aC02VjkuNSB6Ii8+PHBhdGggZmlsbD0iI2M3NDM0MyIgZD0iTTY3LDF2MzhIMTNWMUg2NyBNNTgsMTBoMWg1aDFWOVY0VjNoLTFoLTVoLTF2MXY1VjEwIE0xNSwxMGgxaDVoMVY5VjRWM2gtMWgtNWgtMXYxdjVWMTAgTTU4LDE5aDEgaDVoMXYtMXYtNXYtMWgtMWgtNWgtMXYxdjVWMTkgTTE1LDE5aDFoNWgxdi0xdi01di0xaC0xaC01aC0xdjF2NVYxOSBNNTgsMjhoMWg1aDF2LTF2LTV2LTFoLTFoLTVoLTF2MXY1VjI4IE0xNSwyOGgxaDVoMXYtMXYtNSB2LTFoLTFoLTVoLTF2MXY1VjI4IE01OCwzN2gxaDVoMXYtMXYtNXYtMWgtMWgtNWgtMXYxdjVWMzcgTTE1LDM3aDFoNWgxdi0xdi01di0xaC0xaC01aC0xdjF2NVYzNyBNNjgsMEgxMnY0MGg1NlYwTDY4LDB6IE01OSw5VjQgaDV2NUg1OUw1OSw5eiBNMTYsOVY0aDV2NUgxNkwxNiw5eiBNNTksMTh2LTVoNXY1SDU5TDU5LDE4eiBNMTYsMTh2LTVoNXY1SDE2TDE2LDE4eiBNNTksMjd2LTVoNXY1SDU5TDU5LDI3eiBNMTYsMjd2LTVoNXY1SDE2IEwxNiwyN3ogTTU5LDM2di01aDV2NUg1OUw1OSwzNnogTTE2LDM2di01aDV2NUgxNkwxNiwzNnoiLz48L2c+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTI4IDE4SDUyVjIySDI4eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1LjAwMSA0MC4wMDcgMjAuMDA4KSIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0zOCA4SDQyVjMySDM4eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1LjAwMSA0MC4wMyAyMC4wMjkpIi8+PC9zdmc+';
    },
    periods() {
      return [
        { label: i18n.t('parameters.period.week'), value: 'week' },
        { label: i18n.t('parameters.period.month'), value: 'month' },
        {
          label: i18n.t('parameters.period.trimester'),
          value: 'trimester',
        },
        {
          label: i18n.t('parameters.period.semester'),
          value: 'semester',
        },
        { label: i18n.t('parameters.period.year'), value: 'year' },
      ];
    },
    fields() {
      return [
        { key: 'check', label: '', class: 'd-none d-md-table-cell' },
        {
          key: 'id',
          id: '0',
          label: i18n.t('table.list.id'),
          sortable: true,
          class: 'd-none d-lg-table-cell',
        },
        {
          key: 'thumbnail',
          id: '1',
          label: i18n.t('table.list.preview'),
          sortable: false,
          class: 'd-none d-lg-table-cell w-150px',
        },
        {
          key: 'title',
          id: '2',
          label: i18n.t('table.list.title'),
          sortable: true,
          class: 'd-none d-md-table-cell',
        },
        {
          key: 'active',
          id: '3',
          label:  window.process.env.CLIENT_NAME =='empreinte' ? i18n.t('table.list.statut'): i18n.t('table.list.active'),
          sortable: false,
          class: 'd-none d-md-table-cell',
        },
        {
          key: 'dateStart',
          id: '4',
          label: i18n.t('table.list.date'),
          sortable: true,
          class: 'd-none d-lg-table-cell',
        },
        {
          key: 'actions',
          id: '5',
          label: i18n.t('table.list.actions'),
          sortable: false,
          class: 'd-none d-md-table-cell actions-td',
        },
        { key: 'mobile-details', id: '6', class: 'd-table-cell d-md-none' },

        { key: 'show_details', id: '7', class: 'd-table-cell d-md-none w-50px' },
      ];
    },
    disabledSendButton() {
      return !this.selectedGroupUser && this.form.emails.length === 0;
    },
    getColorModal() {
      return {
        background: this.getActiveColor,
      };
    },
    getActiveColor() {
      return common.getSafeColor(this.$route.query.color);
    },
  },
  methods: {
    ...mapActions({
      paginate: 'lives/paginate',
      getAllContributors: 'lives/fetchContributors',
      deleteMultiLive: 'lives/deleteMultiLive',
      deleteLiveById: 'lives/deleteLiveById',
      setDisableLiveById: 'lives/setDisableLiveById',
      setEnableLiveById: 'lives/setEnableLiveById',
      getLiveById: 'lives/getLiveById',
      getInfosDetail: 'lives/getInfosDetail',
      getLinkExport: 'lives/getLinkExport',
      getSubscriptionUserList: 'lives/getSubscriptionUserList',
      getSubscriptionGroupUsersList: 'lives/getSubscriptionGroupUsersList',
      sendInvitationsMails: 'lives/sendInvitationsMails',
      sendSendGridEmail: 'lives/sendSendGridEmail',
      sendInvitationsGroupMails: 'lives/sendInvitationsGroupMails',
      setScreenShare: 'lives/setScreenShare',
      getUrlDownloadFile: 'lives/getUrlDownloadFile',
      setDiffusionObject: 'lives/setDiffusionObject',
      setLives: 'lives/setLives',
      removeLiveById: 'lives/removeLiveById',
      isArchivedLive: 'lives/isArchivedLive',
      setDiffusion: 'common/setDiffusionLive',
      setStopLiveById: 'lives/setStopLiveById',
      setStartLiveById: 'lives/setStartLiveById',
      restoreArchivedLive: 'lives/restoreArchivedLive',
      restoreArchivedMultiLive: 'lives/restoreArchivedMultiLive',
      deleteMultipleLives: 'lives/deleteMultipleLives',
      deleteLiveByOne: 'lives/deleteLiveByOne',
      syncLivesSockets: "socket/syncLivesSockets",
    }),
    isArrayInfoLive(urlDiffusion) {
      if (urlDiffusion) {
        let checkArray = (urlDiffusion.indexOf('[') + urlDiffusion.indexOf(']')) > -1;
        return checkArray
      }
    },
    parsingArrayUrlDiffusion(urlDiffusion) {
      let subStringArray = urlDiffusion.substring(1, urlDiffusion.length - 1);
      return subStringArray.toString().split(',')
    },
    async openModalDeleteMultiLive() {
      acces_send('lives_multi_delete_action')
      NProgress.start();
      this.isArchivedMulti = this.isTrashDiffusion ? 'deleting' : 'archiving';
      await this.setDeleteLiveActivity(this.isTrashDiffusion ? 'deleting' : 'archiving', {}, true);
      NProgress.done();
    },
    async setActionDeleteLive({ live, action, multi }) {
      switch (action) {
        case 'archiving':
          if (this.isArchivingMultiLive) {
            let list = { live_list: this.selectedList, action: action };
            this.indeterminate = false;
            await this.restoreArchivedMultiLive(list)
          } else {
            await this.restoreArchivedLive({ id: live.id, action: action })
          }
          await this.hasErrorDeleteMulti(live, action, multi);
          break;
        case 'restoring':
          await this.restoreArchivedLive({ id: live.id, action: action })
          await this.hasErrorDeleteMulti(live, action, multi);
          break;
        case 'deleting':
          if (multi) {
            await this.deleteListMultiLive();
          } else {
            await this.removeLiveById(live.id)
            await this.deleteLiveByOne(live.id)
          }
          await this.hasErrorDeleteMulti(live, action, multi);
          break;
      }
    },
    async hasErrorDeleteMulti(live, action, multi) {
      let response = this.getResponseDelete
      let type = 'success';
      if (response.error) {
        type = 'error';
        if (response.multi) {
          if (response.action === 'deleting') {
            const livesShadow = [].concat(this.allLives);
            this.setLives(livesShadow);
            this.showTrash = true;
          }
        }
      } else {
        type = 'success';
        this.showTrash = false;
      }

      await this.callToast(type, live, action, multi)
    },
    callToast(type, live, action, multi) {
      let message_confirm = i18n.t('toast.error');
      switch (type) {
        case 'success':
          message_confirm = (multi ? i18n.t('modal.direct.checked_elements') : live.title) + i18n.t('modal.direct.' + action + '.success.' + (this.showTrash || multi ? 'multi' : 'simple'));
          this.showToast(type, message_confirm, 'icon-success');
          break;

        case 'error':
          message_confirm = i18n.t('toast.error');
          this.showToast(type, message_confirm, 'icon-warning');
          break;
      }
    },
    handleEditExportPermalink() {
      console.log("handleEditExportPermalink")
      /** todo call edit + verif url live **/
    },
    getActiveLive(isActive, id) {
      return !isActive ? id : '-' + id;
    },
    getButtonVariant(isActive) {
      return !isActive ? this.headerBgVariant : '';
    },
    getNamePermalink(perm) {
      if(perm.includes('/studio-event/')){
        return i18n.t('modal.export.standAlone_permalink_participant');

      }
        return i18n.t('modal.export.standAlone_permalink');
    },
    sortingChanged(ctx) {
      let sortExist = this.fields.find(f => f.key === ctx.sortBy)
      if (sortExist && Object.keys(sortExist).length > 0) {
        this.sortBy = ctx.sortBy;
        this.sortDesc = ctx.sortDesc;
        this.fields.forEach((field, index) => {
          if (field.key === this.sortBy) {
            this.numColumn = index - 1;
          }
        });
        if (this.sortDesc === false) {
          this.sortDirection = 'asc';
          this.sortDesc = true;
        }
        else if (this.sortDesc === true) {
          this.sortDirection = 'desc';
          this.sortDesc = false;
        }
        else {
          this.sortDirection = 'asc';
          this.sortDesc = true;
        }
        this.obj['numColumn'] = this.numColumn;
        this.obj.params['order'] = this.sortDirection;
        this.setDiffusionObject(this.obj);
        this.paginate(this.obj);
      }

    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = '';
      this.infoModal.content = '';
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    toggleFilter() {
      this.active = !this.active;
    },
    hideFilter(e) {
      if (e && e.path) {
        if (e.path.some(item => item.id === 'toggle-filter')) {
          return;
        }
        this.active = false;
      }
    },
    clearSelected(event) {
      this.allSelected = false;
      this.checkedItems = [];
    },
    openDropDownDiffusion() {
      this.diffusionSelected = !this.diffusionSelected;
    },
    changeDiffusion(type) {
      switch (type) {
        case 'all':
          acces_send('lives_dtable_lives_all_action');
          break
        case 'archived':
          acces_send('lives_dtable_lives_archived_action');
          break
        case 'endless':
          acces_send('lives_dtable_lives_endless_action');
          break
        case 'upcoming':
          acces_send('lives_dtable_lives_upcoming_action');
          break
        case 'trash':
          acces_send('lives_dtable_lives_trash_action')
      }
      this.obj['type'] = type;
      this.obj.params.start = 0
      this.paginate(this.obj);
      this.titleSelected = type;
      this.setDiffusionObject(this.obj);
      let previewLive = false;
      if (type === 'archived') {
        previewLive = true;
      }
      this.isArchivedLive(previewLive);
      this.setTotalRows(this.allLives.length);
      this.setDiffusion(type);
      window.parent.postMessage(
        {
          info: 'diffusionLive',
          value: type,
        },
        '*',
      );
    },
    getLivesByParams(event, param) {
      let value = event;

      if (param === 'startDate' && value !== null) {
        var date = event;
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = date.getFullYear();
        date = yyyy + '-' + mm + '-' + dd;
        value = date;
      }
      if (value === null) {
        value = '';
      }

      this.obj.params[param] = value;
      this.setDiffusionObject(this.obj);
    },
    reset() {
      this.selectedContributor = '';
      this.period = '';
      this.mdTime = { date: '', time: '', endtime: '' };
      this.obj.params['idContributor'] = '';
      this.obj.params['period'] = '';
      this.obj.params['startDate'] = '';
      this.search();
    },
    search() {
      this.paginate(this.obj);
      this.toggleFilter();
    },
    getLivesByContributor(event) {
      if (event === null) {
        event = {
          id: '',
          name: '',
        };
      }
      this.selectedContributor = event.name;
      this.obj.params['idContributor'] = event.id;
      this.setDiffusionObject(this.obj);
    },
    changePerPage(event) {
      this.setTotalRows(event);
      this.currentPage = 1;
      this.obj.params.currentPage = 1;
      this.obj.params.length = event;
      this.obj.params.start = 0
      this.setDiffusionObject(this.obj);
      this.paginate(this.obj);
    },
    changeNumPage(event) {
      this.obj.params.start = (event - 1) * this.obj.params.length
      this.obj.params.currentPage = event;
      this.setDiffusionObject(this.obj);
      this.paginate(this.obj);
    },
    checkAllLiveRows(event) {
      this.checked = !this.checked;
      this.checkedItems = !(this.allSelected ? this.tableValues : []);
      let idSelectedLive = [];
      let idSelectedRows = [];
      this.allLives.forEach(live => {
        idSelectedLive.push(live.id);
        idSelectedRows.push(live);
      });
      this.$emit('list-all-deleted', {
        state: event,
        listRows: idSelectedRows,
        listId: idSelectedLive,
      });
    },
    CheckRowLive(event, row) {
      let idSelectedLive = row.item.id;
      this.$emit('list-multi-deleted', { state: event, row: row.item, id: idSelectedLive });
    },
    GoToAddLive() {
      acces_send('lives_post_add_action')
      parent.postMessage(
        {
          info: 'goToAddLive',
          value: this.getDiffusion,
        },
        '*',
      );
      const cryptext = this.$route.query;
      let createLive = 'CreateLive';
      if (window.process.env.HAS_SKIN === 'true') {
        createLive = 'CreateLiveV2';
      }
      this.$router.push({ name: createLive, query: cryptext });
      //this.eventPostMessage();
    },
    GoToEditLive(idLive) {
      const cryptext = this.$route.query;
      let editLive = 'EditLive';
      if (window.process.env.HAS_SKIN === 'true') {
        editLive = 'EditLiveV2';
      }
      this.$router.push({ name: editLive, params: { id: idLive }, query: cryptext });
      //this.eventPostMessage();
    },
    setTotalRows(number) {
      this.totalRows = number;
    },
    openDeleteModal() {
      this.$refs['modal-delete-rows'].show();
    },
    async deleteListMultiLive() {
      this.indeterminate = false;
      let selectedRowIndexes = [];
      const livesShadow = [].concat(this.allLives);

      this.selectedList.forEach(id => {
        this.removeLiveById(id);
      });
      this.selectedRows.forEach(row => {
        let index = this.allLives.indexOf(row);
        if (index !== -1) {
          selectedRowIndexes.push(index);
        }
      });
      await this.deleteMultipleLives({ list_to_delete: this.selectedList })
    },

    closeViewModalById() {
      //this.showAllSlides = !this.showAllSlides;
      this.$root.$emit('bv::hide::modal', 'modal-view-row');
      // this.$refs['modal-view-row'].hide();
    },
   openModalFlowLive(flow) {
  this.urlFlow = flow;
  this.$root.$emit('bv::show::modal', 'modal-flow-live-row');
  setTimeout(() => {
    const modal = document.querySelector('#modal-flow-live-row');
    if (modal) {
      modal.style.setProperty('--primary-color', this.getActiveColor);
    }
    const header = document.querySelector('#modal-flow-live-row .modal-header');
    if (header) {
      header.style.setProperty('background-color', this.getActiveColor, 'important');
    }
  }, 300);
},
    async ChangeActivity(event, live) {
      let self = this;
      NProgress.start();
      this.liveId = live.id;
      this.liveObject = live;
      if (event === true) {
        this.isSatusChanged = true;
        this.statusLive = 'start';
      } else {
        this.isSatusChanged = false;
        this.statusLive = 'stop';
      }
      setTimeout(async () => {
        await self.$root.$emit('bv::show::modal', 'modal-' + this.statusLive + '-live');
      }, 100)
      NProgress.done();
    },
    async setDeleteLiveActivity(action, live, multi) {
      let self = this;
      NProgress.start();
      if (!multi) {
        if (Object.keys(live).length > 0) {
          this.liveId = live.id;
          this.liveObject = live;
        }
        this.isArchivedMulti = ''
      }

      this.isMultiDelete = multi;
      if (action === 'archiving') {
        this.isRestoreingLive = false;
        this.isArchivingLive = true;
      } else if (action === 'restoring') {
        this.isRestoreingLive = true;
        this.isArchivingLive = false;
      } else {
        this.isRestoreingLive = false;
        this.isArchivingLive = false;
      }
      this.titleOnDeletedLive = action;
      setTimeout(async () => {
        await self.$root.$emit('bv::show::modal', 'modal-' + this.titleOnDeletedLive + '-live');
      }, 100)
      NProgress.done();
    },
    searchFilter(event) {
      this.obj.params['searchWord'] = event;
      this.obj.params.start = 0;
      this.setDiffusionObject(this.obj);
      this.paginate(this.obj);
    },

    closeInfosModal() {
      this.$root.$emit('bv::hide::modal', 'modal-infos-live-row');
      // this.$refs['modal-infos-live-row'].hide();
    },
    closeExportLinkModal() {
      this.$root.$emit('bv::hide::modal', 'modal-link-export-row');
      //this.$refs['modal-link-export-row'].hide();
    },
    closeSendInvitationsModal() {
      this.$root.$emit('bv::hide::modal', 'modal-send-invitations-row');
      //this.$refs['modal-send-invitations-row'].hide();
    },
    closeSendGroupInvitationsModal() {
      this.$root.$emit('bv::hide::modal', 'modal-send-group-mails-row');
      //this.$refs['modal-send-invitations-row'].hide();
    },
    cancelAddGroupMailsModal() {
      this.form.defaultChoice = false;
    },
    goToAddEmailsModal() {
      this.form.defaultChoice = true;
    },
    goToCalendar() {
      parent.postMessage(
        {
          info: 'goToCalendar',
        },
        '*',
      );
      const cryptext = this.$route.query;
      this.$router.push({ name: 'CalendarLives', query: cryptext });
      // this.eventPostMessage();
    },
    copyExportLink(event, id, index) {
      event.target.classList.add('is-selected');
      var link = this.$refs[id];
      if (id === 'embed') {
        this.clickedEmbed = true;
        this.clickedPermalink = false;
        this.clickedModerator = false;
        this.clickedJournalist = false;
        this.clickedUrlExport = false;
      } else if (id === 'permalink') {
        this.clickedEmbed = false;
        this.clickedPermalink = true;
        this.clickedModerator = false;
        this.clickedJournalist = false;
        this.clickedUrlExport = false;
      } else if (id === 'link_moderator') {
        this.clickedEmbed = false;
        this.clickedPermalink = false;
        this.clickedModerator = true;
        this.clickedJournalist = false;
        this.clickedUrlExport = false;
      } else if (id === 'link_journalist') {
        this.clickedEmbed = false;
        this.clickedPermalink = false;
        this.clickedJournalist = true;
        this.clickedModerator = false;
        this.clickedUrlExport = false;
      } else {
        this.clickedEmbed = false;
        this.clickedPermalink = false;
        this.clickedModerator = false;
        this.clickedJournalist = false;
        this.clickedUrlExport = true;
      }
      if (link && ((link.length >= 1 && link.length !== 2) || link.length === 2)) {
        for (var i = 0; i < link.length; i++) {
          if (i === index) {
            link[i].setAttribute('type', 'text');
            link[i].select();
            if (id === 'permalink' && i === index) {
              this.permalinkIndex = i;
            }
          }
        }
      } else {
        link.setAttribute('type', 'text');
        link.select();
      }

      try {
        var successful = document.execCommand('copy');
        if (successful) {
          event.target.classList.remove('is-selected');
        }
      } catch (err) {
        console.log('unable to copy');
      }
      let self = this;
      setTimeout(function () {
        if (id == 'embed') {
          self.clickedEmbed = false;
        } else if (id == 'permalink') {
          self.clickedPermalink = false;
        } else if (id == 'link_moderator') {
          self.clickedModerator = false;
        } else if (id == 'link_journalist') {
          self.clickedJournalist = false;
        } else {
          self.clickedUrlExport = false;
        }
      }, 1000);
    },
    selectUser(event, email) {
      event.target.classList.toggle('is-selected');
      if (event.target.classList.contains('is-selected')) {
        this.invitations.push(email);
      } else {
        this.invitations.splice(this.invitations.indexOf(email), 1);
      }
      if (Object.keys(this.invitations).length > 0) {
        this.selectedUser = true;
      } else {
        this.selectedUser = false;
      }
    },
    selectGroupUser(event, id) {
      event.target.classList.toggle('is-group-selected');
      if (event.target.classList.contains('is-group-selected')) {
        this.groupInvitations.push(id);
      } else {
        this.groupInvitations.splice(this.groupInvitations.indexOf(id), 1);
      }
      if (Object.keys(this.groupInvitations).length > 0) {
        this.selectedGroupUser = true;
      } else {
        this.selectedGroupUser = false;
      }
    },
    addNewEmail(email) {
      this.groupMails = email;
      this.form.defaultChoice = false;
    },
    removeAddedMail(mail) {
      let exist = this.groupMails.indexOf(mail);
      this.groupMails.splice(exist, 1);
      this.form.emails.splice(exist, 1);
    },
    // onReset(evt) {
    //   evt.preventDefault();
    //   this.form.email = '';
    //   this.show = false;
    //   this.$nextTick(() => {
    //     this.show = true;
    //   });
    // },
    async sendInvitationMail() {
      NProgress.start();
      if (window.process.env.hasSendGrid) {
        let intervenantSendGrid = [];
        this.invitations.map(inv => intervenantSendGrid.push({
          "pic": "-",
          "name": this.getSubscriptionUser.filter(e => e.email == inv)[0]["name"],
          "lastName": this.getSubscriptionUser.filter(e => e.email == inv)[0]["lastName"],
          "description": "-",
          "email": inv
        }))
        var logo = this.liveObject.thumbnail;
        logo = logo ? (logo.indexOf('http') >= 0 ? logo : "https:" + logo) : logo
        let objSendGrid = {
          "cover": logo,
          "logo": logo,
          "title": this.liveObject.title,
          "link": window.process.env.LinkWebinar + "" + this.liveObject.id + "-" + this.liveObject.streamName,
          "webinarId": this.liveObject.id,
          "description": this.liveObject.description,
          "date": moment(this.liveObject.dateStart).format("YYYY-MM-DD"),
          "hour": moment(this.liveObject.dateStart).format("HH:mm"),
          "duration": moment(new Date(new Date(this.liveObject.dateEnd).getTime() - new Date(this.liveObject.dateStart).getTime() + (new Date().getTimezoneOffset() * 60000))).format("HH:mm"),
          "language": "fr",
          "intervenants": intervenantSendGrid,
          "configuration": {
            "templateId": 2,
            "sendRules": {
              "accessEmails": [
                1
              ],
              "subscribedEmails": []
            }
          }
        }

        let message;
        try {
          await this.sendSendGridEmail(objSendGrid)
          message = i18n.t('toast.success_send');
          this.$root.$emit('bv::hide::modal', 'modal-send-invitations-row');
          this.showToast('success', message, 'icon-success');
        } catch (e) {
          message = i18n.t('toast.error');
          this.showToast('error', message, 'icon-warning');
        }
      } else {

        let obj = {
          id: this.liveId,
          mails: this.invitations,
        };
        let message;
        try {
          await this.sendInvitationsMails(obj);
          message = i18n.t('toast.success_send');
          this.$root.$emit('bv::hide::modal', 'modal-send-invitations-row');
          this.showToast('success', message, 'icon-success');
        } catch (e) {
          message = i18n.t('toast.error');
          this.showToast('error', message, 'icon-warning');
        }

      }
      this.invitations = [];
      NProgress.done();
    },
    async sendInvitationGroupMails() {
      NProgress.start();
      let obj = {
        id: this.liveId,
        groups: this.groupInvitations,
        mails: this.groupMails,
      };
      let message;
      try {
        await this.sendInvitationsGroupMails(obj);

        message = i18n.t('toast.success_send');
        this.$root.$emit('bv::hide::modal', 'modal-send-group-mails-row');
        this.showToast('success', message, 'icon-success');
      } catch (e) {
        message = i18n.t('toast.error');
        this.showToast('error', message, 'icon-warning');
      }
      this.groupInvitations = [];
      this.groupMails = [];
      NProgress.done();
    },

    async updateScreenShare(screenType) {
      NProgress.start();
      let objectShare = {
        id: this.liveId,
        screenType: screenType,
      };
      let message;
      try {
        await this.setScreenShare(objectShare);
        this.paginate(this.obj);
        message = i18n.t('toast.success_edit');
        this.$root.$emit('bv::hide::modal', 'modal-screen-share-row');
        this.showToast('success', message, 'icon-success');
      } catch (e) {
        message = i18n.t('toast.error');
        this.showToast('error', message, 'icon-warning');
      }
      NProgress.done();
    },
    closeScreenShareModal() {
      this.$root.$emit('bv::hide::modal', 'modal-screen-share-row');
    },
    async downloadScreenFile(id) {
      NProgress.start();
      let message;
      try {
        await this.getUrlDownloadFile(id);
        message = i18n.t('toast.success_download');
        this.showToast('success', message, 'icon-success');
      } catch (e) {
        message = i18n.t('toast.error');
        this.showToast('error', message, 'icon-warning');
      }
      NProgress.done();
    },
    clearFilterDateLives(param) {
      this.obj.params[param] = '';
      this.setDiffusionObject(this.obj);
    },
    closeModalArchivedVideo() {
      this.$root.$emit('bv::hide::modal', 'modal-preview-archived-video');
    },
    getStatut(item) {
      let currentDAte = new Date();
      let dateStart = new Date(item.dateStart);

      if (item.status === 1)
        return { class: 'badge-secondary', text: 'Archive' };
      else
        if (item.active && item.status !== 1) {
          return { class: 'badge-danger', text: 'Live' };
        } else
          if (!item.active && item.status === -1) {
            return { class: 'badge-warning', text: 'Waiting' };
          } else {
            return { class: 'badge', text: 'error' };
          }
    },
async handleStatusModal() {
      if (this.isLoading) return;
      this.isLoading = true;
      let self = this;
      if (this.statusLive === 'start') {
        this.setEnableLiveById({ id: this.liveObject.id, active: true, streamName: this.liveObject.streamName }); //, obj: this.obj
        this.setStartLiveById(this.liveObject);
        this.liveObject.active = !this.liveObject.active
      } else {
        NProgress.start();
        this.setStopLiveById({ id: this.liveObject.id, active: false, streamName: this.liveObject.streamName,live:this.liveObject });
        setTimeout(function () {
          self.paginate(self.obj);
          NProgress.done();
        }, 3500)
      }
      this.closeStatusModal()
      this.isLoading = false;
    },
    closeStatusModal() {
      this.isSatusChanged = false;
      this.$root.$emit('bv::hide::modal', 'modal-' + this.statusLive + '-live');
    },
    async handleDeleteLiveModal() {
      let live = this.liveObject;
      let action = this.titleOnDeletedLive;
      let multi = false;
      let self = this;
      NProgress.start();
      if (this.isRestoreingLive && !this.isArchivingLive) {
        action = 'restoring'
        multi = false
        live = this.liveObject
      } else if (this.isArchivingLive && !this.isRestoreingLive) {
        action = 'archiving'
        multi = this.isArchivingMultiLive ? true : false;
        live = this.isArchivingMultiLive ? {} : this.liveObject;
      } else {
        action = 'deleting'
        if (this.isMultiDelete) {
          multi = true
          live = {}
        } else {
          multi = false
          live = this.liveObject
        }
      }
      this.closeDeleteLiveModal()
      await this.setActionDeleteLive({ live: live, action: action, multi: multi });
      if (this.isArchivingLive || this.isRestoreingLive) {
        setTimeout(async () => {
          await self.paginate(self.obj);
          NProgress.done();
        }, 200)
      } else {
        NProgress.done();
      }
    },
    closeDeleteLiveModal() {
      this.$root.$emit('bv::hide::modal', 'modal-' + this.titleOnDeletedLive + '-live');
    }
  },

  mounted() {
    this.$root.$on('setFormLang', lang => {

      let firstRow = this.getLinkExportLives['permalien'][0]
      let secondRow = this.getLinkExportLives['permalien'][1]
      let moderatorlink = this.getLinkExportLives['link_moderator'].replace("fr", lang).replace("/en", '/' + lang)
      let journalistlink = this.getLinkExportLives['link_journalist'].replace("fr", lang).replace("/en", '/' + lang)

      firstRow = firstRow.replace("fr", lang).replace("/en", '/' + lang)
      secondRow = secondRow.replace("fr", lang).replace("/en", '/' + lang)

      this.getLinkExportLives['permalien'] = [firstRow, secondRow]
      this.getLinkExportLives['link_moderator'] = moderatorlink
      this.getLinkExportLives['link_journalist'] = journalistlink
    });
    acces_send("lives_dtable_lives_all_action")
    // Set the initial number of items
    this.setTotalRows(this.allLives.length);
    // this.totalRows = this.allLives.length;

    if (Object.keys(this.getDiffusionObject).length > 0) {
      this.obj = this.getDiffusionObject;
      this.titleSelected = this.getDiffusionObject.type;
      this.currentPage = this.getDiffusionObject.params ? this.getDiffusionObject.params.currentPage : this.currentPage;
      this.perPage = this.getDiffusionObject.params ? this.getDiffusionObject.params.length : this.perPage;
      this.obj.params.searchWord="";
    } else {
      this.obj = {
        type: this.getDiffusion,
        numColumn: this.numColumn,
        params: {
          length: this.perPage,
          start: 0,
          order: this.sortDirection,
          orderable: true,
          idContributor: '',
          period: '',
          startDate: '',
          searchWord: '',
          currentPage: 1,
        },
      };
    }
    this.titleSelected = this.getDiffusion;
    this.setDiffusionObject(this.obj)
    if (this.getDiffusion === 'archived') {
      this.isArchivedLive(true);
    }
    if (this.$route.query.archived == "true") { this.obj.type = "trash"; this.isArchived = true }
    this.paginate(this.obj);
    this.getAllContributors();
    eventHub.$on("restartLive", ({ value, count }) => {
      if (value && count === 0) {
        this.changeDiffusion('endless')
        count++
      }
    })

    eventHub.$on("paginateLive", ({ value, count }) => {
      this.paginate(this.obj);
    })

    this.$on('list-multi-deleted', obj => {
      const exist = this.selectedList.indexOf(obj.id);
      if (obj.state === true) {
        if (exist > -1) {
          this.selectedList.splice(exist, 1);
          this.selectedRows.splice(exist, 1);
        } else {
          this.selectedList.push(obj.id);
          this.selectedRows.push(obj.row);
        }
      } else {
        this.selectedList.splice(exist, 1);
        this.selectedRows.splice(exist, 1);
      }
      if (this.selectedList.length > 0) {
        this.showTrash = true;
        this.indeterminate = true;
      } else {
        this.showTrash = false;
        this.indeterminate = false;
      }
    });
    this.$on('list-all-deleted', obj => {
      if (obj.state === true) {
        this.selectedList = obj.listId;
        this.selectedRows = obj.listRows;
      } else {
        this.selectedList = [];
        this.selectedRows = [];
      }
      if (this.selectedList.length > 0) {
        this.showTrash = true;
      } else {
        this.showTrash = false;
      }
    });
    this.$root.$on('setFormLang', lang => {
      //this.$root.i18n.locale = lang;
      console.log('i18n.locale', i18n.locale);
      i18n.locale = lang;
    });
    this.$root.$on('setLiveId', id => {
      this.liveId = id;
    });
    this.$root.$on('setLiveObject', live => {
      console.log(live)
      this.liveObject = live;
    });
    this.$root.$on('ChangeActivity', ({ event, live }) => this.ChangeActivity(event, live))
    this.$root.$on('setUrlFlow', (flow) => this.openModalFlowLive(flow))
    this.$root.$on('setDeleteLiveActivity', ({ action, live, multi }) => this.setDeleteLiveActivity(action, live, multi))
    this.$root.$on('isOpenModal', obj => {
      this.$refs[obj.id].show();
      let id = this.$refs[obj.id].id;
      setTimeout(() => {
        let modal = document.querySelector('#' + id);
        modal.style.setProperty('--primary-color', this.getActiveColor);
        let header = document.querySelector(
          '#' + id + ' .modal-dialog.modal-lg .modal-content .modal-header',
        );
        header.style.setProperty('background-color', this.getActiveColor, 'important');
      }, 100);
    });
    moment.locale('en');
    this.$nextTick(() => {
      if (this.$i18n.locale === 'fr') {
        Datepicker.fecha.i18n.monthNamesShort = [
          'Jan',
          'Fev',
          'Mar',
          'Avr',
          'Mai',
          'Juin',
          'Juil',
          'Aout',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
      }
    });
    this.getSubscriptionUserList();
    this.getSubscriptionGroupUsersList();

    //this.eventPostMessage();
  },
};
</script>

<style scoped lang="scss">
@import '~styles/theme';
@import '../assets/scss/nprogress.scss';
@import 'vue-multiselect/dist/vue-multiselect.min.css';
@import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';

%box-shadow {
  position: relative;
  /*padding: 1em;*/
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;

  /*  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);*/
  /*margin-bottom: 2em;*/
}

.list-live-wrapper {
  padding: 1em 0;

  .live-head {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 20%;
  }

  .live-content-list {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 80%;
  }

  .btn-add-live {
    padding-right: 15px !important;
    padding-left: 0px !important;

    .button-add {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 38px;

      @media all and (-ms-high-contrast: none) {
        display: block;
      }
    }
  }

  .list-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 1em;
    margin: 1em;
  }

  .list-container {
    .table {
      margin-bottom: 0;

      ::v-deep thead {
        th {
          vertical-align: middle;
        }

        th:after {
          line-height: 3;
          padding-bottom: initial;
        }
      }
    }

    .cards {
      padding: 0;
    }
  }

  .cards {
    @extend %box-shadow;
    padding: 1em;
    background-color: #ffffff;
  }

  .card {
    @extend %box-shadow;
  }

  .start-date-picker .input-group .form-control:disabled,
  .form-control[readonly] {
    background-color: transparent;
  }

  .filter-button {
    cursor: pointer;
    padding: 0 5px;
  }

  #diffusion-select {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .input-search {
    position: relative;

    .filter-wrapper {
      position: absolute;
      top: 100%;
      background-color: #ffffff;
      width: 100%;
      padding: 20px;
      z-index: 2;
      margin-top: 5px;
      border-radius: 2px;
      box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14),
        0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
    }

    .input-group {
      align-items: center !important;
    }
  }

  @media screen and (max-width: 1282px) {
    .hide-params {
      display: none;
    }

    .show-params {
      display: block;
    }
  }

  @media screen and (min-width: 1283px) {
    .hide-params {
      display: block;
    }

    .show-params {
      display: none;
    }
  }

  .toggle-menu {
    * {
      box-sizing: border-box;
    }

    #app {
      display: flex;
    }

    aside {
      display: none;
      width: 300px;
      background: #ffffff;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 3;
    }

    aside.active {
      display: block;
    }

    aside a {
      display: block;
      padding: 10px 5px;
      color: #666;
      border-bottom: 1px solid #bbb;
    }

    .wrapper {
      display: flex;
      align-items: stretch;
      flex-direction: column;
      width: 100%;
    }

    header {
      width: 100%;
      padding: 10px;
      background: #aaa;
    }

    main {
      flex-grow: 2;
      padding: 10px;
    }
  }

  .v-select {
    cursor: pointer;
  }

  .show-diffusion {
    display: block !important;
  }

  .actionIcons {
    width: 1em;
    cursor: pointer;
  }

  .icon-trash {
    padding: 0 1em;

    &.icons-trash-diffusion {
      padding: 0;
      font-size: 20px;
    }
  }

  .icon-images {
    background-image: url(data:image/svg+xml;base64,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);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 80px;
    height: auto;
  }

  .input-search {
    .input-group {
      border: 1px solid #cbcbcb;
      border-radius: 2px;
      padding: 0 10px;

      &>.form-control {
        box-shadow: none !important;
        border: none;
      }
    }

    .input-group-append {
      cursor: pointer;
    }
  }

  .start-date-picker {
    .input-group>.form-control {
      box-shadow: none !important;
      border: 1px solid #cbcbcb;
      border-left: none !important;
      border-radius: 2px;
    }

    .form-control:disabled,
    .form-control[readonly] {
      background-color: transparent !important;
      opacity: 1 !important;
      color: #9e9e9e !important;
    }
  }
}

.calendar-lives-btn {
  display: flex;
  align-items: center;
  box-shadow: none !important;

  &:hover {
    text-decoration: none;
  }

  i {
    margin-right: 0.5em;
  }
}

#table-list-lives ::v-deep {
  td {
    position: relative;

    @media screen and (max-width: 360px) {
      padding: 0.75rem 0 0.75rem 0.75rem;
    }
  }

  thead {
    display: none;
  }

  .actions-cell {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    vertical-align: middle;
    align-items: center;
    flex-wrap: wrap;
  }

  .live-content {
    &__thumbnail-container {
      flex: 1 0 0;
      margin-right: 1em;
    }

    &__data {
      flex: 1 0 0;
      position: relative;

      &__title {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /* number of lines to show */
        -webkit-box-orient: vertical;
        /*word-break: break-word;*/
        word-break: break-word;
        overflow-wrap: break-word;
      }

      h4 {
        font-size: 1em;
        margin-bottom: 0;

        @media screen and (max-width: 360px) {
          font-size: 0.8em;
        }
      }

      p {
        color: #777777;
        line-height: 1.2em !important;
        font-size: 80%;
        font-weight: 400;
      }

      &__date {
        font-size: 0.8em;
        font-weight: 600;
        color: #555555;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 0;
        width: 100%;
        margin-top: 0.2em;

        @media screen and (max-width: 360px) {
          font-size: 0.7em;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: left;
          text-align: left;
          width: auto;
        }
      }
    }
  }

  .show-actions-btn {
    box-shadow: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &:hover {
      color: #707070;
    }

    &.active {
      color: #cccccc;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}

@media (min-width: 768px) {
  #table-list-lives ::v-deep {
    thead {
      display: table-header-group;
    }

    [id^='table-list-lives__details_'] {
      display: none !important;
    }
  }
}

.table-wrapper {
  height: 100%;
  height: calc(100vh - 190px);
  overflow: auto;

  #table-list-lives ::v-deep {
    thead th {
      position: sticky;
      top: -1px;
      z-index: 1;
      box-shadow: inset 0 -1px #dee2e6;
      border-bottom: none;
    }

    th {
      background-color: #efefef;
    }

    .actions-td {
      min-width: 170px;
    }
  }
}

@media (max-width: 767px) {
  .lives-pagination ::v-deep {
    .b-pagination {
      li {
        display: none;

        &:nth-child(2),
        &:nth-last-child(2) {
          display: list-item;
        }
      }
    }
  }
}

.is-active {
  background-color: var(--primary-color, $primary-color) !important;

  svg {
    color: #ffffff;
    fill: #ffffff;
  }
}

.usersItems {
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #8e8e8e;
}

.userItem {
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #e1e2e2;
}

.userSpan {
  padding: 0.8em;
  width: 100%;
  display: flex;
  flex-direction: inherit;
}

.is-selected {
  background-color: #f1f3f4;
  color: #252525;
}

.is-copied {
  background-color: orangered;
}

.text-export {
  display: flex;
  justify-content: flex-start;
}

.text-row-export {
  align-items: center;
}

.live-title {
  display: flex;
  justify-content: flex-start;
}

.live-diffusion-title {
  display: flex;
  justify-content: flex-start;
  font-weight: bold;
}

.link-key {
  display: grid;
  grid-template-columns: 4rem 1fr;
  &> * {
    justify-self: start;
    align-self: center;
  }
  & > label {
    margin-bottom: 0;
  }
}


.separator {
  border-top: thin solid rgb(211, 211, 211);
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
}

.live-column {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.live-value {
  display: flex;
  justify-content: flex-end;
}

.live-details {
  border-bottom: 1px solid #efefef;
  padding: 0.5em;
  display: flex;
  justify-content: flex-start;
}

.link-button {
  -webkit-transition-duration: 0.4s;
  /* Safari */
  transition-duration: 0.4s;
  cursor: pointer;
}

.textarea-height {
  height: 135px;
}

.check-icon {
  color: #ffffff;
}

.diffusion-icons {
  padding-right: 10px;
  color: rgba(0, 0, 0, 0.54);

  svg {
    width: 20px;

    g {
      fill: rgba(0, 0, 0, 0.54) !important;

      path {
        fill: rgba(0, 0, 0, 0.54) !important;
      }
    }
  }
}

.diffusion-items {
  margin: 0.5rem;

  &.active {
    background-color: var(--primary-color, $primary-color) !important;

    .diffusion-title,
    .diffusion-icons,
    svg g {
      color: white !important;
      fill: white !important;

      path {
        color: white !important;
        fill: white !important;
      }
    }
  }

  ::v-deep .dropdown-item {
    &.active,
    &:active,
    &:focus,
    &:hover {
      background-color: var(--primary-color, $primary-color) !important;

      .diffusion-title,
      .diffusion-icons,
      svg g {
        color: white !important;
        fill: white !important;

        path {
          color: white !important;
          fill: white !important;
        }
      }
    }
  }
}

.buttons-modal {
  margin: 0 0.5em;
}

.title-selected {
  color: #a2b3c1;
  font-size: 0.7em;
  line-height: -10px !important;
  position: absolute;
  margin-top: -12px;
  margin-left: -28px;

  @media all and (-ms-high-contrast: none) {
    margin-left: 35px;
  }
}

.live-text-title {
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
  color: #495057;
}

.multi-links {
  margin: 10px 0;
}

.multi-buttons {
  margin: 10px;
}

.filter-date {
  .custom-control-label {
    padding-left: 5px;
  }

  .mx-datepicker {
    width: 100%;
  }

  .mx-datepicker.input-text {
    padding: 0 !important;
    border: 1px solid #dee2e6 !important;
    box-shadow: none;
    width: 100%;
  }

  input.mx-input {
    box-shadow: none;
    padding: 0 10px;
  }

  i.mx-input-icon.mx-clear-icon {
    font-size: 14px;
  }
}

.vdp-datepicker {
  &.input-text {
    input[type='text'] {
      font-size: 14px;
    }
  }

  .vdp-datepicker__clear-button {
    position: absolute;
    top: 10px;
    right: 0;
  }
}

.vdp-datepicker__calendar {
  font-size: 14px;

  .input-text {
    input[type='text'] {
      font-size: 14px;
    }
  }
}

::v-deep .selectedDate {
  padding: 0 3.1em;
  background-color: var(--input-bg) !important;
  color: var(--text) !important;
}

::v-deep .mx-input-append {
  left: 0;
  background-color: var(--input-bg) !important;
  width: 42px;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  //color: #495057;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #ced4da;
  border-radius: 0.1em;
}

.thumbnail-image {
  width: 132px;
  height: 75px;
}

.export-position {
  margin-bottom: 15px !important;
}

.text-export-position {
  margin-top: 20px;
}

.text-export-col-position {
  padding-right: 0px;
  margin-top: 15px;
}

.permalink-position {
  margin-bottom: 15px !important;
  align-items: flex-start;
}

.live-text-position {
  margin-top: 0px;
}

.multi-buttons-position {
  margin-top: 2px;
  margin-left: 15px;
}

.textarea-col-position {
  margin-top: 8px;
}

.metadata-info {
  color: #757575;
  margin: 0.4em 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .duration {
    font-size: 0.8em;
    font-weight: 500;
  }
}

.archived-position {
  display: flex;
  justify-content: center;
}

.no-archived-position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  vertical-align: middle;
  text-align: center;
  padding: 30px 0;
}

.no-archived-img {
  width: 100%;
  height: 100px;
}

.no-archived-text {
  color: rgba(0, 0, 0, 0.54);
  font-size: 1.5em;
  font-weight: 500;
  padding: 10px 0;
}

::v-deep .text-muted {
  display: none;
}

.form-email {
  width: 100%;
}

.text-email {
  display: flex;
  justify-content: flex-start;
  font-weight: bold;
  padding: 15px 10px;
  align-items: center;
  margin-bottom: 0;
}

.label-email {
  display: flex;
  justify-content: flex-start;
  padding: 5px 15px;
}

.label-mail-list,
.label-group-list {
  display: flex;
  justify-content: flex-start;
  padding: 0;
}

.input-email {
  border: none;
  border-bottom: 2px solid black !important;
  box-shadow: none;
  border-radius: 1px;
  /*padding: 5px 15px;*/
  margin: 0px 15px;

  /*font-size: 1em;*/
  ::v-deep .input-tag {
    border-radius: 20px;
    /*padding: 5px 25px;*/
    font-size: 1em;
    background-color: #e2e2e2;
    color: #585858;
    border: none;

    >span {
      padding: 5px 5px 5px 15px;
    }

    ::v-deep .remove {
      color: #6c6c6c;
      font-size: 1em;
      padding: 0px 15px;
      font-weight: 400;
    }
  }
}

.group-mails {
  display: flex;
  flex-direction: column;

  &__all {
    &__list {
      display: flex;
      flex-wrap: wrap;
      padding: 10px 0;
      display: flex;
      border-radius: 3px;
      height: 100%;
      width: 100%;

      &__user {
        padding: 5px 25px;
        border-radius: 20px;
        background-color: #e2e2e2;
        margin: 0 5px 10px 0;
        color: #6c6c6c;
        cursor: pointer;
      }

      &__email {
        padding: 5px 5px 5px 25px;
        border-radius: 20px;
        background-color: #4caf50;
        margin: 0 5px 10px 0;
        color: #f1f3f4;
        cursor: pointer;

        span {
          padding: 5px 5px 5px 15px;
        }

        ::v-deep .remove {
          color: #6c6c6c;
          font-size: 1em;
          padding: 0px 15px;
          font-weight: 400;
        }

        .remove {
          color: #f1f3f4;
          padding: 0px 15px;

          &:before {
            content: ' x';
          }
        }
      }
    }
  }
}

.scroll-area-group {
  max-height: 145px;
  min-height: 100px;
  padding: 0 10px;

  &.scroll-group-list {
    max-height: 300px;
  }

  &.scroll-group-mails {
    max-height: 145px;
  }
}

.is-group-selected {
  background-color: var(--primary-color, dodgerblue) !important;
  color: #f1f3f4;
}

.buttons-group-mails {
  border-radius: 5px;
}

.button-add-mail {
  font-weight: 500;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  border-radius: 40px;
  padding: 5px 15px 5px 10px;
  align-items: center;
  text-align: center;
  font-size: 13px;
}

.icon-add-email {
  margin: 0 5px;
}

.list-groups {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  border-top: 1px solid #eaeaea;
}

.add-emails {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

////add new
.buttons-link {
  color: var(--primary-color, $primary-color) !important;

  &:active,
  &::after,
  &:focus {
    color: var(--primary-color, $primary-color) !important;
  }
}

.lives-pagination ::v-deep .pagination .page-item .page-link {
  color: var(--primary-color, $primary-color) !important;
}

.lives-pagination ::v-deep .pagination .page-item.active .page-link,
.lives-pagination ::v-deep .pagination .page-item.active .page-link:hover,
.lives-pagination ::v-deep .pagination .page-item.active .page-link:focus,
.lives-pagination ::v-deep .pagination .page-link[aria-current='page'] {
  color: #fff !important;
  background-color: var(--primary-color, $primary-color) !important;
  border-color: var(--primary-color, $primary-color) !important;
  box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
    0 1px 1px var(--primary-color, $primary-color) !important;
}

::v-deep .mx-panel-date td.today {
  color: var(--primary-color, $primary-color) !important;

  &:active,
  &::after,
  &:focus {
    color: #fff !important;
    background-color: var(--primary-color, $primary-color) !important;
    border-color: var(--primary-color, $primary-color) !important;
    box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
      0 1px 1px var(--primary-color, $primary-color) !important;
  }
}

::v-deep .dropdown-toggle::after {
  color: var(--primary-color, $primary-color) !important;
}

.buttons-primary,
::v-deep .custom-switch,
::v-deep .custom-checkbox,
::v-deep .custom-radio[variant="primary"] {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

::v-deep .custom-switch .custom-control-label::before,
::v-deep .custom-checkbox .custom-control-label::before,
::v-deep .custom-radio[variant="primary"] .custom-control-label::before {
  box-shadow: none !important;
}

::v-deep .custom-switch .custom-control-input:active,
::v-deep .custom-switch .custom-control-input:hover,
::v-deep .custom-switch .custom-control-input:not(:disabled):not(.disabled):active,
::v-deep .custom-switch .custom-control-input:checked ~ .custom-control-label::before,
::v-deep .custom-switch .custom-control-input:indeterminate ~ .custom-control-label::before,
::v-deep .custom-checkbox .custom-control-input:active,
::v-deep .custom-checkbox .custom-control-input:hover,
::v-deep .custom-checkbox .custom-control-input:not(:disabled):not(.disabled):active,
::v-deep .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,
::v-deep .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before,
::v-deep .custom-radio[variant="primary"] .custom-control-input:active,
::v-deep .custom-radio[variant="primary"] .custom-control-input:hover,
::v-deep .custom-radio[variant="primary"] .custom-control-input:not(:disabled):not(.disabled):active,
::v-deep .custom-radio[variant="primary"] .custom-control-input:checked ~ .custom-control-label::before,
::v-deep .custom-radio[variant="primary"] .custom-control-input:indeterminate ~ .custom-control-label::before {
  color: #fff !important;
  background-color: var(--primary-color, $primary-color) !important;
  border-color: var(--primary-color, $primary-color) !important;
  box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
    0 1px 1px var(--primary-color, $primary-color) !important;
}

::v-deep .custom-switch .custom-control-input:checked ~ .custom-control-label::after,
::v-deep .custom-switch .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-color: #fff !important;
}

.buttons-primary,
.buttons-primary:hover,
.buttons-primary:focus,
.buttons-primary:active,
.buttons-primary.active {
  color: #fff !important;
  background-color: var(--primary-color, $primary-color) !important;
  border-color: var(--primary-color, $primary-color) !important;
  box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
    0 1px 1px var(--primary-color, $primary-color) !important;
}

::v-deep .dropdown-item.active,
::v-deep .dropdown-item:active,
::v-deep .vs__dropdown-option:hover,
::v-deep .vs__dropdown-option--highlight,
::v-deep .mx-calendar-content .cell.actived,
::v-deep .bg-primary,
::v-deep .btn-primary,
::v-deep .btn-primary:hover,
::v-deep .btn-primary:focus,
::v-deep .btn-primary:active,
::v-deep .btn-primary.active,
::v-deep .page-item.active .page-link,
::v-deep .page-item.active .page-link:hover,
::v-deep .page-item.active .page-link:focus,
::v-deep .page-link[aria-current='page'] {
  color: #fff !important;
  background-color: var(--primary-color, $primary-color) !important;
  border-color: var(--primary-color, $primary-color) !important;
  box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
    0 1px 1px var(--primary-color, $primary-color) !important;
}

::v-deep #modal-infos-live-row___BV_modal_header_,
::v-deep #modal-preview-archived-video___BV_modal_header_ {
  background-color: var(--primary-color, $primary-color) !important;
  border-color: var(--primary-color, $primary-color) !important;
}

.buttons-outline-primary {
  color: var(--primary-color, $primary-color) !important;
  background-color: #fff !important;
  border-color: var(--primary-color, $primary-color) !important;
  box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
    0 1px 1px var(--primary-color, $primary-color) !important;

  &:active,
  &.active,
  &:hover,
  &:focus {
    color: #fff !important;
    background-color: var(--primary-color, $primary-color) !important;
    border-color: var(--primary-color, $primary-color) !important;
    box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
      0 1px 1px var(--primary-color, $primary-color) !important;
  }
}

.badge-warning {
  background-color: #fe7106;
}

.badge {
  border-radius: 4em;
  display: flex;
  justify-content: center;
  padding: 0.25em 0em !important;
}

//rgb(0,123,255)
.submit {
  background-color: var(--primary-color, $primary-color) !important; 
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  float: right;
  text-align: center;
  right: 30px;
  bottom: 30px;
  height: 40px;
}

.submit:hover {
  background-color: rgb(0, 123, 255);
}

.filter-btn,
.reset-filter-btn {
  text-align: center;
  min-width: 10%;
  margin-left: 3px;

  @media screen and (max-width: 500px) {
    margin-top: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ListLive.vue